import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Lifted off the page with a soft drop; for floating panels, not for data. */
  raised?: boolean;
}

export function Card({ raised = false, className, children, ...rest }: CardProps) {
  return (
    <div className={cx("ui-card", raised && "ui-card--raised", className)} {...rest}>
      {children}
    </div>
  );
}

export interface CardHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}

export function CardHeader({ title, description, actions, className }: CardHeaderProps) {
  return (
    <div className={cx("ui-card__header", className)}>
      <div className="ui-min-w-0">
        <h2 className="ui-card__title">{title}</h2>
        {description && <p className="ui-card__description">{description}</p>}
      </div>
      {actions && <div className="ui-card__actions">{actions}</div>}
    </div>
  );
}

export function CardBody({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cx("ui-card__body", className)} {...rest}>
      {children}
    </div>
  );
}
